import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'underscore';
import { PrimaryNameDisplay } from './primary_name_display';
import { AddNameFormExpander } from './add_name_form_expander';
import { ConfirmedName } from './confirmed_name';
import classNames from 'classnames';

export class MentionsSettingsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      canBeAdded: 0,
      confirmedNames: [],
      deleteNameServerErrors: false,
      addNameErrorMessage: '',
      isAddNameError: false,
      displayName: this.props.displayName,
    };
  }

  componentDidMount() {
    $.getJSON($r.api_v0_structured_names_path({ subdomain_param: 'api' }))
      .done((response) => {
        let names = [];
        if (response.structured_names) {
          names = _.map(response.structured_names, (structuredName) => {
            return {
              id: structuredName.id,
              firstName: structuredName.first_name,
              middleName: structuredName.middle_name || '',
              lastName: structuredName.last_name,
            };
          });
        }
        this.setState({
          confirmedNames: names,
          canBeAdded: 3 - names.length,
          loading: false,
        });
      })
      .fail(() => {
        // maybe we should ignore the failure here and allow users to add names
        alert('Something went wrong!');
      });
  }

  render() {
    const displayNameHeadingClasses = classNames(
      'row col-xs-12 u-ph0x u-mh0x u-textUppercase u-letterSpacing0_5 u-tcGrayDark u-fw500 u-fs12 u-lineHeight1 u-mb0x',
      {
        'u-mt6x': !this.props.modalMode,
      },
    );
    const otherNameHeadingClasses = classNames(
      'row col-xs-12 u-ph0x u-mh0x u-textUppercase u-letterSpacing0_5 u-tcGrayDark u-fw500 u-fs12 u-lineHeight1_0 u-mb0x',
      {
        'u-mt6x': !this.props.modalMode,
      },
    );
    return (
      <div className="DesignSystem u-overflowAuto">
        <div className="u-overflowHidden">
          {this.props.modalMode ? null : (
            <label className="row col-xs-12 u-ph0x u-mh0x u-tcGrayDarkest u-fw500 u-fs20 u-lineHeight1 u-mb0x">
              {' '}
              Name{' '}
            </label>
          )}
          <p className={displayNameHeadingClasses}> Display Name </p>
          <PrimaryNameDisplay
            initialFirstName={$current_user.first_name}
            initialMiddleName={$current_user.middle_initials}
            initialLastName={$current_user.last_name}
            updateDisplayNameCallback={this.updateDisplayName}
            onClearAddNameErrors={this.clearAddNameErrors}
            modalMode={this.props.modalMode}
          />
        </div>
        {Aedu.serviceAvailability.serviceEnabled('mentions_db') && (
          <div>
            <p className={otherNameHeadingClasses}> Other Names </p>
            <span className="row col-xs-12 u-ph0x u-mh0x u-mt2x u-mb4x u-tcGrayDarkest u-fw400 u-fs14 u-lineHeight1_4">
              {' '}
              Have you ever published under a different name? Academia will
              search for&nbsp;
              <span className="u-textDecorationUnderline">Mentions</span> of
              your name(s) to find papers discussing your work.{' '}
            </span>
            <div className="row col-xs-12 u-ph0x u-mh0x">
              {' '}
              {this.state.loading
                ? this.renderLoading()
                : this.renderNames()}{' '}
            </div>
          </div>
        )}
      </div>
    );
  }

  quotedNamesFromCurrentUser = () => {
    const { first_name, last_name, display_name } = Aedu.User.current;
    const names = [];
    names.push(display_name);
    names.push(`${last_name}, ${first_name}`);
    names.push(`${first_name.charAt(0)}. ${last_name}`);

    return _.map(names, (name) => `"${name}"`).join(', ');
  };

  renderErrors() {
    return (
      <div className="rox col-xs-12 u-ph0x u-tcRed u-mv4x">
        {this.state.serverErrors}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="u-taCenter u-pv6x">
        <i className="fa fa-spin fa-spinner u-fs36" />
      </div>
    );
  }

  renderNames() {
    return (
      <div>
        {_.map(this.state.confirmedNames, (structuredName, index) => {
          return (
            <ConfirmedName
              key={index}
              displayName={this.displayName(structuredName)}
              onDelete={this.onNameDelete}
              id={structuredName.id}
              modalMode={this.props.modalMode}
            />
          );
        })}
        <div className="row col-xs-12 u-ph0x u-mh0x">
          {this.state.canBeAdded > 0 && (
            <AddNameFormExpander
              onAdd={this.onNameAdd}
              onCancel={this.clearAddNameErrors}
              onClearAddNameErrors={this.clearAddNameErrors}
              errorMessage={this.state.addNameErrorMessage}
              isError={this.state.isAddNameError}
              modalMode={this.props.modalMode}
            />
          )}
        </div>
      </div>
    );
  }

  onNameDelete = (name) => {
    this.setState({ serverErrors: false });
    $.ajax({
      type: 'DELETE',
      dataType: 'json',
      contentType: 'application/json',
      url: $r.api_v0_structured_name_path({
        subdomain_param: 'api',
        id: name.props.id,
      }),
    })
      .done(() => {
        this.setState(() => {
          const names = _.reject(this.state.confirmedNames, (n) => {
            // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
            // eslint-disable-next-line eqeqeq
            return n.id == name.props.id;
          });
          return {
            canBeAdded: 3 - names.length,
            confirmedNames: names,
          };
        });
      })
      .fail((xhr) => {
        let serverErrors;
        // Just in case the response text isn't JSON
        try {
          serverErrors = JSON.parse(xhr.responseText).errors.join(', ');
        } catch {
          serverErrors =
            'We could not delete your alternate name, please try again';
        }
        this.setState({
          deleteNameServerErrors: serverErrors,
        });
      });
  };

  onNameAdd = (firstName, middleName, lastName) => {
    // assume error unless success so the add name form does not collapse by default
    this.setState({ isAddNameError: true, addNameErrorMessage: '' });
    $.ajax({
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      url: $r.api_v0_structured_names_path({ subdomain_param: 'api' }),
      data: JSON.stringify({
        source: 'settings_page',
        structured_names: [
          {
            first_name: firstName,
            middle_name: middleName || null,
            last_name: lastName,
          },
        ],
      }),
    })
      .done((response) => {
        let names = this.state.confirmedNames;
        names = names.concat({
          id: response.id,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
        });
        this.setState({
          canBeAdded: 3 - names.length,
          confirmedNames: names,
          isAddNameError: false,
        });
      })
      .fail((xhr) => {
        let serverErrors;
        // Just in case the response text isn't JSON
        try {
          serverErrors = JSON.parse(xhr.responseText).errors.join(', ');
        } catch {
          serverErrors =
            'We could not save your alternate name, please try again';
        }
        this.setState({
          isAddNameError: true,
          addNameErrorMessage: serverErrors,
        });
      });
  };

  clearAddNameErrors = () => {
    this.setState({
      isAddNameError: false,
      addNameErrorMessage: '',
    });
  };

  updateDisplayName = (firstName, middleInitials, lastName) => {
    const newDisplayName = [firstName, middleInitials, lastName].join(' ');
    const newConfirmedNames = _.filter(this.state.confirmedNames, (n) => {
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line eqeqeq
      return this.displayName(n).toLowerCase() != newDisplayName.toLowerCase();
    });
    this.setState(
      {
        displayName: newDisplayName,
        confirmedNames: newConfirmedNames,
      },
      () => {
        this.props.primaryNameChangeCallback(newDisplayName);
      },
    );
  };

  displayName = (structuredName) => {
    return [
      structuredName.firstName,
      structuredName.middleName,
      structuredName.lastName,
    ].join(' ');
  };
}
MentionsSettingsContainer.propTypes = {
  displayName: PropTypes.string.isRequired,
  primaryNameChangeCallback: PropTypes.func,
  // if true, hides "Name", compresses spacing
  modalMode: PropTypes.bool,
};
MentionsSettingsContainer.defaultProps = {
  primaryNameChangeCallback: () => {},
  modalMode: false,
};
export default MentionsSettingsContainer;
